/* Upload preview + earlier uploads "Download CSV": pure column maps and the runs loader. */
import {
  collect_all_pages,
  next_offset
} from '../../../../util_components/csv_export/collect_pages';
import { csv_file_name } from '../../../../util_components/csv_export/to_csv';
import { history_view } from './adapters';
import { UPLOAD_LIMITS } from './params';

const raw = (r) => r.row || {};
const teacher = (r) => raw(r).teacher || {};

// An unmatched-teacher issue quotes the file's email; the row number already points Ops to it.
const EMAIL_RE = /[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+/g;
export const hide_emails = (text) => String(text).replace(EMAIL_RE, '(email hidden)');

// No teacher email: the match shows as how it matched, never the address.
export const PREVIEW_CSV_COLUMNS = [
  { header: 'Row', key: 'line', kind: 'number' },
  { header: 'Result', key: 'verdict_label' },
  { header: 'Teacher', value: (r) => teacher(r).name || (raw(r).teacher ? '' : 'Not found') },
  { header: 'Teacher UUID', value: (r) => teacher(r).uuid || '' },
  { header: 'Category', key: 'category_label' },
  { header: 'Amount', value: (r) => raw(r).amount, kind: 'money' },
  {
    header: 'Entry date (IST)',
    value: (r) =>
      raw(r).entry_date
        ? `${raw(r).entry_date}${raw(r).entry_time ? ` ${raw(r).entry_time}` : ''}`
        : '',
    kind: 'datetime'
  },
  { header: 'Reference', value: (r) => raw(r).reference_id || '' },
  { header: 'Related session UUID', value: (r) => raw(r).related_session_uuid || '' },
  { header: 'Note', key: 'note' },
  {
    header: 'Issues',
    value: (r) => [...r.issues.map((i) => i.text), ...r.lookalikes].map(hide_emails)
  }
];

export const preview_csv_name = (pay_month, file_name) =>
  csv_file_name({
    page: 'additional-payments',
    table: `upload-preview ${String(file_name || '').replace(/\.csv$/i, '')}`,
    period: String(pay_month || '').slice(0, 7)
  });

const who = (w) => (w && (w.name || w.uuid)) || '';
const counts = (r) => raw(r).counts || {};

export const HISTORY_CSV_COLUMNS = [
  { header: 'Upload ID', key: 'run_uuid' },
  { header: 'File', key: 'file_name' },
  { header: 'Status', key: 'status_label' },
  { header: 'Uploaded by', value: (r) => who(raw(r).uploaded_by) },
  { header: 'Uploaded at (IST)', value: (r) => raw(r).uploaded_at_ist, kind: 'datetime' },
  { header: 'Total rows', value: (r) => counts(r).total, kind: 'number' },
  { header: 'Valid rows', value: (r) => counts(r).valid, kind: 'number' },
  { header: 'Invalid rows', value: (r) => counts(r).invalid, kind: 'number' },
  { header: 'Outcome', key: 'outcome_text' }
];

export const history_csv_name = (pay_month) =>
  csv_file_name({
    page: 'additional-payments',
    table: 'earlier-uploads',
    period: String(pay_month || '').slice(0, 7)
  });

// Every upload of the month, not just the page on screen.
export const history_csv_loader = (fetch_runs, pay_month) => () =>
  collect_all_pages((offset) => {
    const at = offset || 0;
    return fetch_runs(pay_month, UPLOAD_LIMITS.RUNS_LIMIT_MAX, at).then((data) => {
      const v = history_view(data);
      return {
        rows: v.rows,
        next: next_offset({
          offset: at,
          page_size: UPLOAD_LIMITS.RUNS_LIMIT_MAX,
          row_count: v.rows.length,
          total_count: v.total_count
        })
      };
    });
  });
